<template>
  <SfModalPortal
    data-testid="insights-add-filter-modal"
    modal-id="insights-add-filter-modal"
    size="s"
    :scrollable-content="false"
  >
    <template #title>
      {{ I18n.t('companies_overview.filters.add_filter_button') }}
      <span
        v-if="liteMode"
        class="
          tw-bg-sf-primary-subtle
          tw-rounded-full
          tw-px-2
          tw-py-1
          tw-text-sf-primary-dark
          tw-text-sm
        "
      >
        {{ I18n.t('companies_overview_lite.premium') }}
        <i class="fa fa-gem tw-text-sf-primary-dark tw-ml-1" />
      </span>
    </template>

    <template #body>
      <div class="tw-flex tw-flex-col tw-max-h-modal-content-height">
        <div class="tw-flex-shrink-0 tw-mb-6">
          <AddFilterSearch :lite-mode="liteMode" @edit-filter="close" />
        </div>

        <div class="tw-overflow-y-auto tw-min-h-0">
          <AddFilterGroup
            v-for="group in filterGroups"
            :key="group.nameKey"
            :group="group"
            :lite-mode="liteMode"
            class="last:tw-mb-0 tw-mb-4"
            @edit-filter="close"
          />
        </div>
      </div>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { filterGroups } from '@app/insights/filter-definitions'
import AddFilterGroup from './add-filter-group.vue'
import AddFilterSearch from './add-filter-search.vue'

defineOptions({ name: 'AddFilterModal' })

defineProps<{
  liteMode?: boolean
}>()

const I18n = useI18n()

const close = () => window.modalCitizen.closeModalPortal()
</script>
